"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var DomWidgets_1 = require("./DomWidgets");
var Declarative_1 = require("../utils/Declarative");
var react_1 = require("react");
var InteractiveDom_1 = require("../utils/InteractiveDom");
var TabStyles_1 = require("../styles/TabStyles");
var OutlineActiveBorder = { border: '1px solid white' };
var ColorSwatchSize = 15;
var getColorSwatchWidgetStyle = function (props) {
    return {
        base: {
            width: props.size,
            height: props.size,
            backgroundColor: props.color.toLowerCase(),
            boxSizing: 'border-box'
        },
        interactive: {
            hover: tslib_1.__assign({}, OutlineActiveBorder, { cursor: props.disabled ? 'normal' : 'pointer' }),
            active: OutlineActiveBorder
        }
    };
};
var ColorSwatchWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ColorSwatchWidget, _super);
    function ColorSwatchWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleHover = function (hover) {
            _this.setState({ hover: hover });
        };
        _this.handleActive = function (active) {
            _this.setState({ active: active });
        };
        _this.handleClick = function () {
            if (!_this.props.disabled) {
                _this.props.handleClick(_this.props.color.toLowerCase());
            }
        };
        _this.state = { hover: false, active: false };
        return _this;
    }
    ColorSwatchWidget.prototype.render = function () {
        var styles = getColorSwatchWidgetStyle(this.props);
        var interactiveProps = {
            interactiveStyles: styles.interactive,
            handleHover: this.handleHover,
            handleActive: this.handleActive,
            pointerClick: this.handleClick,
            disabled: this.props.disabled
        };
        return (react_1.createElement(InteractiveDom_1.InteractiveDomWrapper, interactiveProps, react_1.createElement('div', {
            style: tslib_1.__assign({}, styles.base, Declarative_1.conditional(this.props.selected, OutlineActiveBorder)),
            'aria-selected': this.props.selected,
            'data-tb-test-id': Declarative_1.testId(this.props.testId, 'ColorSwatch', this.props.color.toLowerCase())
        }, Declarative_1.conditional(!this.props.disabled, react_1.createElement('div', { style: this.getInnerBorderStyle() })))));
    };
    ColorSwatchWidget.prototype.getInnerBorderStyle = function () {
        var showInnerBorder = this.props.selected || this.state.hover || this.state.active;
        var innerBorderColor = (showInnerBorder && TabStyles_1.TabStyles.Colors ? TabStyles_1.TabStyles.Colors.F9 : 'transparent');
        return { borderWidth: 1, borderStyle: 'solid', borderColor: innerBorderColor, width: '100%', height: '100%', boxSizing: 'border-box' };
    };
    return ColorSwatchWidget;
}(React.Component));
exports.ColorSwatchWidget = ColorSwatchWidget;
var ColorGridType;
(function (ColorGridType) {
    ColorGridType[ColorGridType["Default"] = 0] = "Default";
    ColorGridType[ColorGridType["Minimal"] = 1] = "Minimal";
})(ColorGridType || (ColorGridType = {}));
exports.ColorGridType = ColorGridType;
var ColorGridPreset;
(function (ColorGridPreset) {
    ColorGridPreset[ColorGridPreset["Dark"] = 0] = "Dark";
    ColorGridPreset[ColorGridPreset["Light"] = 1] = "Light";
    ColorGridPreset[ColorGridPreset["MaestroFlowColors"] = 2] = "MaestroFlowColors";
})(ColorGridPreset || (ColorGridPreset = {}));
exports.ColorGridPreset = ColorGridPreset;
var ColorGridWidget = /** @class */ (function (_super) {
    tslib_1.__extends(ColorGridWidget, _super);
    function ColorGridWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSwatchClicked = function (color) {
            if (!_this.props.disabled) {
                _this.props.handleSwatchClicked(color.toLowerCase());
            }
        };
        _this.getColorSwatchGridBuilder = function (gridType) {
            switch (gridType) {
                default:
                case ColorGridType.Default:
                    return _this.buildDefaultColorSwatchGrid();
                case ColorGridType.Minimal:
                    return _this.buildMinimalColorSwatchGrid();
            }
        };
        _this.preset = _this.props.colorsPreset || ColorGridPreset.Dark;
        return _this;
    }
    ColorGridWidget.prototype.render = function () {
        if (this.props.colorsPreset && this.props.colorsPreset !== this.preset) {
            this.preset = this.props.colorsPreset;
        }
        return react_1.createElement(DomWidgets_1.Block, { 'data-tb-test-id': Declarative_1.testId(this.props.testId, 'ColorGrid'), tabIndex: 0 }, react_1.createElement(InteractiveDom_1.InteractiveDomWrapper, {
            interactiveStyles: {
                focus: { outline: 'none' }
            }
        }, this.getColorSwatchGridBuilder(this.props.gridType)));
    };
    ColorGridWidget.prototype.getColorPreset = function () {
        switch (this.preset) {
            default:
            case ColorGridPreset.Dark:
                return TabStyles_1.TabStyles.ColorPickerPresets.Dark;
            case ColorGridPreset.Light:
                return TabStyles_1.TabStyles.ColorPickerPresets.Light;
            case ColorGridPreset.MaestroFlowColors:
                return TabStyles_1.TabStyles.ColorPickerPresets.MaestroFlowColors;
        }
    };
    ColorGridWidget.prototype.buildMinimalColorSwatchGrid = function () {
        this.colorsPerColumn = 4;
        var columns = [];
        var colors = this.getColorPreset();
        var currentColumn = [];
        var currentGroup = [];
        var colorsInColumn = 0;
        for (var i = 0; i < colors.length; i++) {
            var color = colors[i].toLowerCase();
            var colorSwatchProps = {
                color: color,
                handleClick: this.handleSwatchClicked,
                key: 'swatch-' + color,
                size: ColorSwatchSize,
                selected: this.props.selectedColor === color,
                disabled: this.props.disabled,
                testId: this.props.testId
            };
            currentGroup.push(react_1.createElement(ColorSwatchWidget, colorSwatchProps));
            colorsInColumn += 1;
            // when we reached the max number of colors in a column or we are about the add a divider, then we need to flush the group and render
            // as a div with gray borders
            if (colorsInColumn === this.colorsPerColumn) {
                currentColumn.push(react_1.createElement('div', { style: { border: '1px solid ' + TabStyles_1.TabStyles.Colors.L6 }, key: 'group-' + i }, currentGroup));
                if (colorsInColumn === this.colorsPerColumn) {
                    columns.push(react_1.createElement('div', { key: 'column-' + i, style: { float: 'left', marginTop: 0, marginRight: 0, marginBottom: 0,
                            marginLeft: (columns.length ? ColorGridWidget.groupSpacingPx : 0) } }, currentColumn));
                    currentColumn = [];
                    colorsInColumn = 0;
                }
                currentGroup = [];
            }
        }
        return react_1.createElement('div', { style: { display: 'flex' }, tabIndex: 0 }, columns);
    };
    ColorGridWidget.prototype.buildDefaultColorSwatchGrid = function () {
        this.colorsPerColumn = 6;
        var columns = [];
        var colors = this.getColorPreset();
        var currentColumn = [];
        var currentGroup = [];
        var colorsInColumn = 0;
        for (var i = 0; i < colors.length; i++) {
            var color = colors[i].toLowerCase();
            var colorSwatchProps = {
                color: color,
                handleClick: this.handleSwatchClicked,
                key: 'swatch-' + color,
                size: ColorSwatchSize,
                selected: this.props.selectedColor === color,
                disabled: this.props.disabled,
                testId: this.props.testId
            };
            currentGroup.push(react_1.createElement(ColorSwatchWidget, colorSwatchProps));
            colorsInColumn += 1;
            // for the first 2 columns (gray colors) we will have a divider after the first color swatch, after that the divider is after the 3rd
            var addDivider = colorsInColumn === 1 && columns.length < 2 || colorsInColumn === 3 && columns.length >= 2;
            // when we reached the max number of colors in a column or we are about the add a divider, then we need to flush the group and render
            // as a div with gray borders
            if (colorsInColumn === this.colorsPerColumn || addDivider) {
                currentColumn.push(react_1.createElement('div', { style: { border: '1px solid ' + TabStyles_1.TabStyles.Colors.L6 }, key: 'group-' + i }, currentGroup));
                if (addDivider) {
                    currentColumn.push(react_1.createElement('div', { style: { width: ColorSwatchSize, height: ColorGridWidget.dividerHeightPx },
                        key: 'divider-' + i }));
                }
                if (colorsInColumn === this.colorsPerColumn) {
                    columns.push(react_1.createElement('div', { key: 'column-' + i, style: { float: 'left', marginTop: 0, marginRight: 0, marginBottom: 0,
                            marginLeft: (columns.length ? ColorGridWidget.groupSpacingPx : 0) } }, currentColumn));
                    currentColumn = [];
                    colorsInColumn = 0;
                }
                currentGroup = [];
            }
        }
        return react_1.createElement('div', { style: { display: 'flex' }, tabIndex: 0 }, columns);
    };
    ColorGridWidget.groupSpacingPx = 4; // got this number from tableau server
    ColorGridWidget.dividerHeightPx = 5;
    return ColorGridWidget;
}(React.Component));
exports.ColorGridWidget = ColorGridWidget;
//# sourceMappingURL=ColorGridWidget.js.map